export default function initMobileMenu() {
  const menuOpeners = document.querySelectorAll('.btn-search, .search-link a, .search-popup .close');
  const body = document.querySelector('body');
  const openedClass = 'seacrh-opened';
  const menuClass = 'menu-opened';
  
  const openCloseMenu = (e) => {
    e.preventDefault();
    
    body.classList.toggle(openedClass)
    if(body.classList.contains(menuClass)) body.classList.remove(menuClass)
  }

  menuOpeners.forEach(opener => {
    opener.addEventListener('click', openCloseMenu);
  })
}
